export const colors = {
  'action-primary': '#c84062',
  'action-primary-hovered': '#9c2446',
  'action-primary-pressed': '#7c1634',
  'action-primary-subdued': '#fff5f6',
  'action-primary-subdued-hovered': '#fff0f2',
  'action-primary-subdued-pressed': '#ffdfe3',
  'action-primary-disabled': '#faf8f4',
  'action-neutral': '#FFFFFF',
  'action-neutral-hovered': '#faf8f4',
  'action-neutral-pressed': '#f5f3ef',
  'action-neutral-subdued': '#f5f3ef',
  'action-neutral-subdued-hovered': '#e8e6e2',
  'action-neutral-subdued-pressed': '#d5d4d0',
  'action-neutral-disabled': '#FFFFFF',
  'action-destructive': '#d83028',
  'action-destructive-hovered': '#a71613',
  'action-destructive-pressed': '#840a08',
  'action-destructive-subdued': '#fff5f3',
  'action-destructive-subdued-hovered': '#fff0ec',
  'action-destructive-subdued-pressed': '#ffe0da',
  'action-destructive-disabled': '#f5f3ef',
  background: '#f5f3ef',
  'background-hovered': '#e8e6e2',
  'background-pressed': '#d5d4d0',
  'background-selected': '#d5d4d0',
  'background-backdrop': '#00000080',
  'background-overlay': '#ffffff80',
  'background-divider': '#a3a19e',
  content: '#070606',
  'content-subdued': '#545452',
  'content-muted': '#737270',
  'content-hovered': '#171717',
  'content-pressed': '#545452',
  'content-disabled': '#a3a19e',
  'content-on-positive': '#004b22',
  'content-on-attention': '#663200',
  'content-on-highlight': '#04255b',
  'content-on-negative': '#840a08',
  'content-on-negative-hovered': '#580202',
  'content-on-negative-pressed': '#380101',
  'content-primary': '#530920',
  'content-on-primary': '#FFFFFF',
  'content-on-inverse': '#faf8f4',
  'content-on-destructive': '#FFFFFF',
  'content-on-interactive': '#FFFFFF',
  'content-on-background': '#070606',
  'content-on-background-subdued': '#545452',
  'content-on-background-hovered': '#171717',
  'content-on-background-pressed': '#545452',
  'content-on-background-disabled': '#a3a19e',
  interactive: '#9c2446',
  'interactive-hovered': '#7c1634',
  'interactive-pressed': '#530920',
  'interactive-disabled': '#faf8f4',
  'interactive-destructive': '#d83028',
  'interactive-destructive-hovered': '#a71613',
  'interactive-destructive-pressed': '#840a08',
  'interactive-destructive-disabled': '#faf8f4',
  topbar: '#FFFFFF',
  'topbar-subdued': '#f5f3ef',
  'content-on-topbar': '#070606',
  'line-on-topbar': '#d5d4d0',
  'line-on-topbar-pressed': '#737270',
  link: '#9c2446',
  'link-hovered': '#7c1634',
  'link-pressed': '#530920',
  line: '#d5d4d0',
  'line-subdued': '#e8e6e2',
  'line-hovered': '#a3a19e',
  'line-pressed': '#737270',
  'line-selected': '#545452',
  'line-disabled': '#e8e6e2',
  'line-transparent': '#0000001a',
  'line-positive': '#00612f',
  'line-positive-subdued': '#90e6af',
  'line-highlight': '#1650ab',
  'line-highlight-subdued': '#b4d8ff',
  'line-negative': '#a71613',
  'line-negative-subdued': '#ffc7bc',
  'line-negative-disabled': '#ffe0da',
  'line-attention': '#844200',
  'line-attention-subdued': '#ffcb89',
  focused: '#9c2446',
  skeleton: '#e8e6e2',
  surface: '#FFFFFF',
  'surface-subdued': '#f5f3ef',
  'surface-hovered': '#f5f3ef',
  'surface-subdued-hovered': '#e8e6e2',
  'surface-pressed': '#e8e6e2',
  'surface-disabled': '#faf8f4',
  'surface-selected': '#fff5f6',
  'surface-selected-hovered': '#fff0f2',
  'surface-selected-pressed': '#ffdfe3',
  'surface-attention': '#ffe2bb',
  'surface-attention-subdued': '#fff7ed',
  'surface-negative': '#ffe0da',
  'surface-negative-subdued': '#fff5f3',
  'surface-negative-subdued-hovered': '#fff0ec',
  'surface-negative-subdued-pressed': '#ffe0da',
  'surface-positive': '#c1f2d0',
  'surface-positive-subdued': '#f2fbf5',
  'surface-highlight': '#d3e8ff',
  'surface-highlight-subdued': '#f4f9ff',
  'surface-highlight-subdued-hovered': '#e9f3ff',
  'surface-highlight-subdued-pressed': '#d3e8ff',
  'surface-neutral': '#e8e6e2',
  'surface-neutral-subdued': '#faf8f4',
  'surface-inverse': '#171717',
  'decorative-surface-1': '#FFC96B',
  'decorative-surface-1-subdued': '#FFE4B5',
  'decorative-content-1': '#7E5700',
  'decorative-surface-2': '#FFC4B0',
  'decorative-surface-2-subdued': '#FFE1D7',
  'decorative-content-2': '#AF294E',
  'decorative-surface-3': '#92E6B5',
  'decorative-surface-3-subdued': '#C9F3DA',
  'decorative-content-3': '#006D41',
  'decorative-surface-4': '#91E0D6',
  'decorative-surface-4-subdued': '#C8EFEB',
  'decorative-content-4': '#006A68',
  'decorative-surface-5': '#FDC9D0',
  'decorative-surface-5-subdued': '#FEE4E7',
  'decorative-content-5': '#AE2B4C',
  'decorative-surface-6': '#7CD4FD',
  'decorative-surface-6-subdued': '#BDE9FE',
  'decorative-content-6': '#065986',
  'decorative-surface-7': '#BDB4FE',
  'decorative-surface-7-subdued': '#DED9FF',
  'decorative-content-7': '#4A1FB8',
}
